<template>
  <section
    class="about-section section-padding"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
    v-if="variants.v1 === variant"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-6 col-lg-6 wow fadeInUp animated" data-wow-delay="200ms">
          <div class="tw-w-full">
            <iframe
              v-if="!vars.isPopupBool && vars.videoUrl"
              class="tw-w-full tw-object-cover"
              :src="vars.videoUrl"
              frameborder="0"
              allowfullscreen
              :style="vars.isVerticalBool ? 'aspect-ratio:5/8' : 'aspect-ratio:16/9'"
            ></iframe>

            <LibraryImage
              v-else-if="vars.photoImage && !vars.videoUrl"
              :src="vars.photoImage"
              :w-ratio="vars.isVerticalBool ? 9 : 645"
              :h-ratio="vars.isVerticalBool ? 16 : 430"
            />

            <div
              v-else-if="vars.photoImage && vars.videoUrl && vars.isPopupBool"
              class="tw-relative tw-w-full"
              @click="isVisible = true"
            >
              <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
                <svg width="80" height="80" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="81" cy="81" r="81" fill="white" />
                  <polygon points="65,45 115,81 65,117" fill="black" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-10">
          <div class="about-content-wrapper">
            <div class="section-title">
              <div>
                <h2>
                  <svg
                    v-if="vars.isVisibleBool"
                    width="1em"
                    height="52"
                    viewBox="0 0 41 47"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="flex-shrink-0"
                    style="display: inline"
                  >
                    <rect width="40.9678" height="40.9678" fill="#E4002B" />
                    <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                    <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                    <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                    <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                    <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                    <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                    <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                    <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                    <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                    <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                    <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                    <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                    <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                    <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                    <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                    <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                    <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                  ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
                </h2>
              </div>
            </div>
            <div class="p-animation">
              <p v-for="(item, index) in descriptions" :key="index" class="tw-mb-9">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="about-section section-padding"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="container">
      <div :class="['row align-items-center', vars.isReversedBool ? 'flex-lg-row-reverse' : '']">
        <div class="col-xl-6 col-lg-6 wow fadeInUp animated" data-wow-delay="200ms">
          <div class="about-img-wrapper">
            <library-image
              v-if="vars.photoImage"
              :src="vars.photoImage"
              :width="613"
              :height="613"
              class="object-cover"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-10">
          <div class="about-content-wrapper">
            <div class="section-title">
              <h2>
                <svg
                  v-if="vars.isVisibleBool"
                  width="1em"
                  height="52"
                  viewBox="0 0 41 47"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                  style="display: inline"
                >
                  <rect width="40.9678" height="40.9678" fill="#E4002B" />
                  <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
              </h2>
            </div>

            <div class="p-animation">
              <p v-for="(item, index) in descriptions" :key="index" class="tw-mb-9">
                {{ item.description }}
              </p>
            </div>

            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="`n-${vars.buttonTypeText} n-btn tw-mt-2`"
            >
              <div class="n-btn-container">
                <div class="n-btn-group">
                  <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    class="about-section section-padding"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
    v-if="variants.v3 === variant"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 tw-text-center">
          <div class="section-title">
            <h2>
              <svg
                v-if="vars.isVisibleBool"
                width="1em"
                height="52"
                viewBox="0 0 41 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex-shrink-0"
                style="display: inline"
              >
                <rect width="40.9678" height="40.9678" fill="#E4002B" />
                <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" />
              </svg>
              <span v-if="vars.isVisibleBool">&nbsp;</span>
              {{ vars.titleText }}
            </h2>
          </div>
        </div>

        <!-- Video - Ortada büyük -->
        <div class="col-12">
          <div class="tw-mx-auto tw-w-full tw-max-w-4xl">
            <iframe
              v-if="!vars.isPopupBool && vars.videoUrl"
              class="tw-w-full tw-object-cover"
              :src="vars.videoUrl"
              frameborder="0"
              allowfullscreen
              :style="
                vars.isVerticalBool ? 'aspect-ratio:5/8; min-height: 500px;' : 'aspect-ratio:16/9; min-height: 400px;'
              "
            ></iframe>

            <LibraryImage
              v-else-if="vars.photoImage && !vars.videoUrl"
              :src="vars.photoImage"
              :w-ratio="vars.isVerticalBool ? 9 : 16"
              :h-ratio="vars.isVerticalBool ? 16 : 9"
              class="tw-w-full tw-rounded-lg"
              style="min-height: 400px; object-fit: cover"
            />

            <div
              v-else-if="vars.photoImage && vars.videoUrl && vars.isPopupBool"
              class="tw-relative tw-w-full tw-cursor-pointer tw-overflow-hidden tw-rounded-lg"
              @click="isVisible = true"
              style="min-height: 400px; background-color: #888"
            >
              <LibraryImage
                :src="vars.photoImage"
                :w-ratio="16"
                :h-ratio="9"
                class="tw-h-full tw-w-full tw-object-cover"
              />
              <button
                class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-white tw-p-4 tw-shadow-lg tw-transition-transform hover:tw-scale-110"
              >
                <svg width="60" height="60" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="81" cy="81" r="81" fill="rgba(255,255,255,0.9)" />
                  <polygon points="65,45 115,81 65,117" fill="#E4002B" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Açıklama ve Buton - Altta ortada -->
        <div class="col-12">
          <div class="about-content-wrapper text-center tw-mx-auto -tw-mt-24 tw-max-w-4xl md:tw-my-0">
            <div class="p-animation">
              <p v-for="(item, index) in descriptions" :key="index" class="tw-mb-6 tw-text-lg tw-leading-relaxed">
                {{ item.description }}
              </p>
            </div>
            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="`n-${vars.buttonTypeText}`"
            >
              {{ vars.buttonLabelText }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>

   
  
  <section
  v-if="variants.v4 === variant"
  class="about-section section-padding"
  :style="`
    background-color: var(--c-${vars.backgroundColor});
    color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}
  `"
>
  <div class="container">
    <!-- Burada isReversedBool kontrolü eklendi -->
    <div :class="['row align-items-center', vars.isReversedBool ? 'flex-lg-row-reverse' : '']">
      <div class="col-xl-6 col-lg-6 wow fadeInUp animated" data-wow-delay="200ms">
        <div class="tw-w-full">
          <iframe
            v-if="!vars.isPopupBool && vars.videoUrl"
            class="tw-w-full tw-object-cover"
            :src="vars.videoUrl"
            frameborder="0"
            allowfullscreen
            :style="vars.isVerticalBool ? 'aspect-ratio:5/8' : 'aspect-ratio:16/9'"
          ></iframe>

          <LibraryImage
            v-else-if="vars.photoImage && !vars.videoUrl"
            :src="vars.photoImage"
            :w-ratio="vars.isVerticalBool ? 9 : 645"
            :h-ratio="vars.isVerticalBool ? 16 : 430"
          />

          <div
            v-else-if="vars.photoImage && vars.videoUrl && vars.isPopupBool"
            class="tw-relative tw-w-full"
            @click="isVisible = true"
          >
            <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
              <svg width="80" height="80" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
                <circle cx="81" cy="81" r="81" fill="white" />
                <polygon points="65,45 115,81 65,117" fill="black" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-10">
        <div class="about-content-wrapper">
          <div class="section-title">
            <div>
              <h2>{{ vars.titleText }}</h2>
            </div>
          </div>
          <div class="p-animation">
            <p
              v-for="(item, index) in descriptions"
              :key="index"
              class="tw-mb-9"
            >
              {{ item.description }}
            </p>

            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="`n-${vars.buttonTypeText} n-btn tw-mt-2`"
            >
              <div class="n-btn-container">
                <div class="n-btn-group">
                  <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
